// Small controls shared by the App Tasks page, its edit drawer and dialogs: the on/off
// switch, the highlight star, and the environment / category pills.

import type { TaskCategoryRead } from "../api/types";

export const ENV_COLOR: Record<string, string> = {
  residential: "var(--accent)",
  commercial: "#3b5bdb",
};
export function envColor(slug: string): string {
  return ENV_COLOR[slug] ?? "var(--gray)";
}
export function catColor(cat: { color: string | null } | null | undefined): string {
  return cat?.color ?? "#7c877f";
}

export function Switch({
  checked,
  onChange,
  disabled,
  label,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  label: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      className="at-switch"
      disabled={disabled}
      onClick={() => onChange(!checked)}
    />
  );
}

export function StarButton({
  on,
  onToggle,
  disabled,
}: {
  on: boolean;
  onToggle: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      className="at-star"
      aria-pressed={on}
      title={on ? "Remove highlight" : "Highlight in the app"}
      disabled={disabled}
      onClick={onToggle}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2.5l2.9 6.2 6.8.8-5 4.7 1.3 6.8L12 17.7 5.9 21l1.3-6.8-5-4.7 6.8-.8z" />
      </svg>
    </button>
  );
}

export function EnvPill({ slug, name }: { slug: string; name: string }) {
  return (
    <span className="at-pill at-pill-dot" style={{ ["--sc" as string]: envColor(slug) }}>
      {name}
    </span>
  );
}

export function CategoryPill({
  cat,
  fallbackName,
}: {
  cat: TaskCategoryRead | { name: string; color: string | null; is_active?: boolean } | null | undefined;
  fallbackName?: string;
}) {
  const name = cat?.name ?? fallbackName ?? "—";
  const inactive = cat != null && cat.is_active === false;
  return (
    <span className="at-pill" style={{ ["--sc" as string]: catColor(cat) }}>
      {name}
      {inactive && <span className="at-pill-note">· inactive</span>}
    </span>
  );
}
